<template>
  <v-container fluid>
    <div class="modal-padding myt-scroll">
      <v-row>
        <v-col cols="10" sm="10">
          <div class="label-datacus">
            Test Name: {{ data.stepOneData.testName }}
          </div>
        </v-col>
        <v-col cols="2" sm="2" class="test-cross">
          <!-- <span @click="onClose({ status: false})">X</span> -->
          <v-icon @click="onClose({ status: false })" class="close-md"
            >mdi-close</v-icon
          >
        </v-col>
      </v-row>
      <div class="tb-test-table">
        <div class="mobile-scroll-table">
          <div class="question-table-header">
            <div class="cust-test-row head-col myt-test-create-row">
              <div class="col-myt-2">Sections</div>
              <div class="col-myt-2">No. of Questions</div>
              <div class="col-myt-2">Mandatory Questions</div>
              <div class="col-myt-1">&nbsp;</div>
            </div>
          </div>
          <div class="border-tb"></div>
          <div class="cust-test-scroll-sub">
            <div
              class="cust-test-row myt-test-create-row"
              v-for="(que, idx) in questionsTypeList"
              :key="que.id"
            >
              <div class="col-myt-2 section-txt">
                {{ que.subject.text + " " + showQuestionType(que) }}
              </div>
              <div class="col-myt-2">
                <v-text-field
                  type="number"
                  v-model="que.numberOfQuestion"
                  @input="que.noOfMandatoryQuestions = que.numberOfQuestion"
                  min="1"
                  dense
                  hide-details
                ></v-text-field>
              </div>
              <div class="col-myt-2">
                <div
                  v-if="
                    que.questionType.id != QUE_TYPES.COMPREHENSION &&
                      que.questionType.id != QUE_TYPES.TC
                  "
                >
                  <v-text-field
                    type="number"
                    v-model="que.noOfMandatoryQuestions"
                    min="0"
                    dense
                    hide-details
                  ></v-text-field>
                </div>
              </div>
              <div class="col-myt-1 deleteicon">
                <v-btn
                  class="cust-btn"
                  @click="removeType(idx)"
                  color="primary"
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </div>
            </div>
          </div>
        </div>
      </div>
      <v-row>
        <v-col cols="12" sm="12" class="btn-myt-create">
          <div class="pull-left">
            <v-btn
              class="left-btn cust-btn"
              @click="processCustomTestData(true)"
              color="primary"
              :disabled="disableCreateTest"
              >Create Full Test</v-btn
            >
          </div>
          <div class="pull-right">
            <v-btn
              class="right-btn cust-btn"
              @click="processCustomTestData(false)"
              color="primary"
              :disabled="disableCreateTest"
              >Customize Syllabus</v-btn
            >
          </div>
        </v-col>
      </v-row>
    </div>
    <AlertBox
      :width="modalwidth"
      :onClose="onCloseAlertBox"
      :component="cComponent"
      :status="open"
      :data="customErrorMsg"
      :onCustomizeClick="onCustom"
    />
  </v-container>
</template>
<script>
import { mapActions, mapState } from "vuex";
import constants from "../../../../utils/constants";
import moment from "moment";

export default {
  name: "customizedMYTTestsSubPopup",
  props: ["onClose", "status", "data", "onCustomizeClick"],
  data() {
    return {
      subQuestionLength: 0,
      disableCreateTest: false,
      showCustomizeSyllabus: false,
      open: false,
      cComponent: null,
      modalwidth: "1000px",
      customErrorMsg: "",
      onCustom: null
    };
  },
  computed: {
    ...mapState("questionStore", ["questionsTypeList"])
  },
  mounted() {
    this.showCustomizeSyllabus =
      localStorage.getItem("dummyQuestionTest") === "true";
    let modules = JSON.parse(localStorage.getItem("modules"));
  },
  methods: {
    ...mapActions({
      getDataTreeWithLevelPublic: "utilStore/getDataTreeWithLevelPublic",
      createMytTest: "testStore/createMytTest"
    }),
    showPartialMarking(que) {
      if (
        que.questionType.id === this.QUE_TYPES.MULTIPLE_CORRECT ||
        (que.questionType.id === this.QUE_TYPES.COMPREHENSION &&
          que.selectedSubType &&
          (que.selectedSubType == this.QUE_TYPES.COMPREHENSION_2Q_MA ||
            que.selectedSubType == this.QUE_TYPES.COMPREHENSION_3Q_MA))
      ) {
        return true;
      }
      return false;
    },
    removeType(idx) {
      if (this.questionsTypeList.length == 1) {
        this.$toasted.error("Alteast Questions One type Needed.");
        return;
      }
      this.questionsTypeList.splice(idx, 1);
    },
    processTestData(submit) {
      this.disableCreateTest = true;
      if (this.validateQuestionTypes()) {
        this.$root.showLoader = true;
        let questions = [];
        let questionNo = 1;
        let optionalQuestionsList = [];
        optionalQuestionsList = this.getMandatoryQuestions(
          this.questionsTypeList
        );
        this.questionsTypeList.map((xx) => {
          for (let k = 0; k < xx.numberOfQuestion; k++) {
            let currentQuestion = {
              index: questionNo,
              subIndex: xx.subIndex,
              subject: {
                ...xx.subject.value,
                difficulty: xx.subject.difficulty
              },
              chapterId: xx.chapterId,
              selectedSubType: xx.selectedSubType,
              question_text: this.DUMMYTEXT,
              solution: this.DUMMYTEXT,
              correct_answer: null,
              options: [],
              options_abc: [],
              options_pqr: [],
              hints: [{ text: this.DUMMYTEXT }],
              questions: [],
              startValue: null,
              endValue: null,
              questionType: xx.questionType,
              question_type: xx.questionType.id,
              subtype: xx.selectedSubType,
              correctMarkingSchema: 1,
              inCorrectMarkingSchema: 0,
              partialMarking: this.showPartialMarking(xx)
                ? xx.partialMarking
                : false,
              required_questions: parseInt(xx.numberOfQuestion)
            };
            currentQuestion = this.setDummyAnswerAsPerType(currentQuestion);
            questions.push(currentQuestion);
            questionNo++;
          }
        });
        // if (submit && !this.showCustomizeSyllabus) {
        let questionList = questions;  //removing getQuestionArray(questions)
        this.createTest(questionList, optionalQuestionsList);
        // } else if (submit && this.showCustomizeSyllabus) {
        // this.createCustomTest(questions, optionalQuestionsList);
        // } else {
        // this.onCustomizeClick({ questions, optionalQuestionsList });
        // }
      }
    },
    processCustomTestData(submit, confirmCreate) {
      if (this.validateQuestionTypes() && this.validateSubjects()) {
        this.disableCreateTest = true;
        this.$root.showLoader = true;
        let questions = [];
        let questionNo = 1;
        let optionalQuestionsList = [];
        let patternData=this.data && this.data.patternData ? this.data.patternData : null;
        optionalQuestionsList = this.getMandatoryQuestions(
          this.questionsTypeList
        );
        this.questionsTypeList.map((xx) => {
          let currentQuestion = {
            index: questionNo,
            subIndex: xx.subIndex,
            subject: { ...xx.subject.value, difficulty: xx.subject.difficulty },
            chapterId: xx.chapterId,
            selectedSubType: xx.selectedSubType,
            question_text: this.DUMMYTEXT,
            solution: this.DUMMYTEXT,
            correct_answer: null,
            options: [],
            options_abc: [],
            options_pqr: [],
            hints: [{ text: this.DUMMYTEXT }],
            questions: [],
            startValue: null,
            endValue: null,
            questionType: xx.questionType,
            question_type: xx.questionType.id,
            subtype: xx.selectedSubType,
            correctMarkingSchema: patternData && patternData.positive_marks ? patternData.positive_marks : 1,
            inCorrectMarkingSchema: patternData && patternData.negative_marks ? patternData.negative_marks : 0,
            partialMarking: this.showPartialMarking(xx)
              ? xx.partialMarking
              : false,
            required_questions: parseInt(xx.numberOfQuestion),
            l1_questions_required:xx.subject.easy,
            l2_questions_required:xx.subject.moderate,
            l3_questions_required:xx.subject.tough,

          };
          currentQuestion = this.setDummyAnswerAsPerType(currentQuestion);

          questions.push(currentQuestion);
          questionNo++;
        });
        let questionList = questions;  //removing getQuestionArray(questions)
        if (submit) {
          this.createCustomTest(
            questionList,
            optionalQuestionsList,
            confirmCreate
          );
        } else {
          this.onCustomizeClick({ questionList, optionalQuestionsList });
        }
      }
    },
    createTest(questions, optionalQuestionsList) {
      let stepOneData = this.data.stepOneData;
      let list = [];
      let forUpdate = false;
      let patternData=this.data && this.data.patternData ? this.data.patternData : null;

      questions.map((q, i) => {
        let obj = {
          index: i + 1,
          subIndex: q.subIndex,
          question_text: q.question_text,
          question_type: q.questionType.id,
          subtype: q.subtype,
          data_type_id: q.chapterId,
          correct_marks: patternData && patternData.positive_marks ? patternData.positive_marks : 1,
          negative_marks: patternData && patternData.negative_marks ? patternData.negative_marks : 0,
          partial_marking: q.partialMarking,
          required_questions: parseInt(q.required_questions),
          questions: q.questions,
          solution: q.solution,
          noOfMandatoryQuestions: q.noOfMandatoryQuestions,
          subject: this.getSubjectId(q.subject),
          hints: this.getHintsForRequest(q.hints),
          sub_subject: q.subject.code
        };
        if (q.id) {
          obj.id = q.id;
          forUpdate = true;
        }

        if (
          q.questionType.id === this.QUE_TYPES.INTEGER ||
          q.questionType.id === this.QUE_TYPES.SUBJECTIVE ||
          q.questionType.id === this.QUE_TYPES.SUBJECTIVEINTEGER ||
          q.questionType.id === this.QUE_TYPES.COMPREHENSION_2Q_NU
        ) {
          obj.correct_answer = q.correct_answer;
        } else {
          obj.correct_answer = "-";
        }
        if (
          q.questionType.id === this.QUE_TYPES.ASSERTION_REASON ||
          q.questionType.id === this.QUE_TYPES.MULTIPLE_CORRECT ||
          q.questionType.id === this.QUE_TYPES.SINGLE_CORRECT_SEC2 ||
          q.questionType.id === this.QUE_TYPES.SINGLE_CORRECT ||
          q.questionType.id === this.QUE_TYPES.COMPREHENSION ||
          q.questionType.id === this.QUE_TYPES.COMPREHENSION_2Q_SA ||
          q.questionType.id === this.QUE_TYPES.COMPREHENSION_2Q_MA ||
          q.questionType.id === this.QUE_TYPES.COMPREHENSION_3Q_SA ||
          q.questionType.id === this.QUE_TYPES.COMPREHENSION_3Q_MA ||
          q.questionType.id === this.QUE_TYPES.COMPREHENSION_2Q_MM ||
          q.questionType.id === this.QUE_TYPES.TC ||
          q.questionType.id === this.QUE_TYPES.TC_3Q_SA ||
          q.questionType.id === this.QUE_TYPES.TC_2Q_SA
        ) {
          obj.options = q.options;
        } else if (q.questionType.id === this.QUE_TYPES.MATRIX_MATCH) {
          obj.options = q.options_abc.concat(q.options_pqr);
        } else if (q.questionType.id === this.QUE_TYPES.MATRIX_MATCH_OPTION) {
          obj.options = q.options.concat(q.options_abc).concat(q.options_pqr);
        }

        list.push(obj);
      });
      let isOnline = localStorage.getItem("isOnlineTest");

      let reqData = {
        list: list,
        target_exam: stepOneData.targetSelected.target_exam_id,
        test_type: stepOneData.testType
          ? stepOneData.testType
          : this.TEST_TYPE.CUSTOM,
        duration: 60,
        test_name: stepOneData.testName,
        optionalQuestionsList: optionalQuestionsList,
        is_online_test: isOnline === "Online" ? 1 : 0,
        // institute_id: myInstitute.id,
        institute_id: 2,
        creator_id: "temp" + moment().format("X")
      };
      if (forUpdate) {
        reqData.only_question = true;
      }
      if (stepOneData.testId) {
        reqData.id = stepOneData.testId;
      }
      this.createMytTest(reqData)
        .then((response) => {
          this.loading = false;
          this.$toasted.success(`Success\n${response.msg}`, {
            icon: "check_circle"
          });
          // if (forUpdate) {
          this.onClose({ status: false, reloadPreview: true });

          this.$root.showLoader = false;
        })
        .catch((err) => {
          this.$root.showLoader = false;
          this.disableCreateTest = false;
        });
    },
    createCustomTest(questions, optionalQuestionsList, confirmation) {
      let stepOneData = this.data.stepOneData;
      let stepTwoData = this.data.stepTwoData;
      let myInstitute = JSON.parse(localStorage.getItem("myInstitute"));
      let creatorId = localStorage.getItem("guest_user_id");
      let userData = JSON.parse(sessionStorage.getItem("user"));
      let questionTypes = this.data.questionTypes;
      this.$root.showLoader = true;
      let isOnline = localStorage.getItem("isOnlineTest");
      let { list, forUpdate } = this.createTestData(
        { questions, optionalQuestionsList },
        confirmation,
        true
      );
      let reqData = {
        list: list,
        target_exam: stepOneData.targetSelected.target_exam_id,
        test_type: stepOneData.testType
          ? stepOneData.testType
          : this.TEST_TYPE.CUSTOM,
        duration: 60,
        test_name: stepOneData.testName,
        optionalQuestionsList: optionalQuestionsList,
        is_online_test: isOnline === "Online" ? 1 : 0,
        // institute_id: myInstitute.id,
        institute_id: myInstitute.id,
        creator_id: userData ? userData.id.toString() : creatorId
      };
      if (forUpdate) {
        reqData.only_question = true;
      }
      if (stepOneData.testId) {
        reqData.id = stepOneData.testId;
      }
      if (confirmation) {
        reqData.allowed_dummy_question = true;
      }
      this.createMytTest(reqData)
        .then((response) => {
          this.loading = false;
          let subjectCustomMsg = [];
          if (response.code === 204) {
            this.$root.showLoader = true;
            response.list.map((s) => {
              subjectCustomMsg.push(
                `${s.required_dummy_questions} questions of ${
                  s.sub_type
                    ? questionTypes.find((q) => q.value.id === s.sub_type).text
                    : questionTypes.find(
                        (q) => q.value.id === s.question_type_id
                      ).text
                } from  ${
                  stepTwoData.selectedSubjects.find(
                    (sub) =>
                      sub.value.id === s.subject_id ||
                      sub.value.code === s.sub_subject
                  ).text
                }`
              );
              // subjectCustomMsg.push(`${s.required_questions} questions requested for ${stepOneData.selectedSubjects.find(sub=> sub.id === s.subject_id).title} subject with question type ${questionTypes.find(q=>q.value.id === s.question_type_id).text} only ${s.available} are available`)
            });
            // subjectCustomMsg = subjectCustomMsg.join(",\n")
            this.customErrorMsg = subjectCustomMsg;
            // this.customErrorMsg= "Out of " + subjectCustomMsg + ". Do you want to change the parameters OR keep those questions dummy and edit them manually?"
            this.cComponent =
              "views/pages/mytuser/components/customizedMYTTestAlertBox";
            this.modalwidth = "525px";
            this.open = true;
            this.$forceUpdate();
          } else {
            this.$root.showLoader = false;

            this.$toasted.success(`Success\n${response.msg}`, {
              icon: "check_circle"
            });
            // if (forUpdate) {
            this.onClose({
              status: false,
              reloadPreview: true
            });
            // } else {
            //   this.$router.push({ name: "customized-tests-myt" });
            // }
          }
          this.disableCreateTest = false;

          this.$root.showLoader = false;
        })
        .catch((err) => {
          this.$root.showLoader = false;
          this.disableCreateTest = false;
        });
    },
    onCloseAlertBox(data) {
      this.open = data.status;
      this.disableCreateTest = false;
      if (data.confirm) {
        this.processCustomTestData(true, data.confirm);
      }
    },
    validateQuestionTypes() {
      let valid = true;
      this.questionsTypeList;
      let currentTypeName = "";
      for (let i = 0; i < this.questionsTypeList.length; i++) {
        const currentType = this.questionsTypeList[i];

        currentTypeName =
          currentType.subject.title + " " + currentType.questionType.title;
        if (!currentType.questionType || !currentType.questionType.id) {
          this.$toasted.error(
            `Please select question type for .${currentTypeName} `,
            { icon: "info" }
          );
          valid = false;
          break;
        } else if (
          !currentType.numberOfQuestion ||
          currentType.numberOfQuestion < 1
        ) {
          this.$toasted.error(
            `Please enter number of question for ${currentTypeName}`,
            { icon: "info" }
          );
          valid = false;
          break;
        } else if (
          currentType.questionType.id != this.QUE_TYPES.COMPREHENSION &&
          currentType.questionType.id != this.QUE_TYPES.TC &&
          (!currentType.noOfMandatoryQuestions ||
            parseInt(currentType.numberOfQuestion) <
              parseInt(currentType.noOfMandatoryQuestions) ||
            parseInt(currentType.noOfMandatoryQuestions) == 0)
        ) {
          this.$toasted.error(
            `Please enter valid number of mandatory questions for ${currentTypeName}`,
            { icon: "info" }
          );
          valid = false;
          break;
        }
      }
      if (valid == false) {
        this.disableCreateTest = false;
      }
      return valid;
    },
    isValidPattern(num) {
      let regex = /^0$|^-?[1-9]\d*(\.\d+)?$/;
      if (regex.test(num)) {
        return true;
      }
      return false;
    },
    showQuestionType(que) {
      return que.selectedSubType && que.selectedSubType
        ? this.data.questionTypes.find(
            (q) => q.value.id === que.selectedSubType
          ).text
        : que.questionType.title;
    },
    validateSubjects() {
      let valid = true;
      let subjects = [];

      for (let i = 0; i < this.questionsTypeList.length; i++) {
        let sub = {};
        let count = 0;

        let xx = this.questionsTypeList[i];
        let index = subjects.findIndex(
          (x) =>
            x &&
            x.id ==
              (xx.subject.parent_id === 144
                ? xx.subject.parent_id + xx.subject.code
                : xx.subject.id)
        );
        if (index > -1) {
          subjects[index].count =
            subjects[index].count + parseInt(xx.numberOfQuestion);
        } else {
          sub = {
            id:
              xx.subject.parent_id === 144
                ? xx.subject.parent_id + xx.subject.code
                : xx.subject.id,
            count: count + parseInt(xx.numberOfQuestion)
          };
          subjects.push(sub);
        }
      }
      if (JSON.parse(localStorage.getItem("dummyQuestionTest")) === true) {
        for (let i = 0; i < subjects.length; i++) {
          if (subjects[i].count > constants.QUESTIONS_LIMIT[subjects[i].id]) {
            this.$toasted.error(
              `You have exceeded the maximum allowed questions. \nYou can add a maximum of 100 questions in Physics, Chemistry, Mathematics, Botany and Zoology`,
              { icon: "info" }
            );
            valid = false;
            break;
          }
        }
      }
      return valid;
    }
  },
  watch: {
    status() {
      this.showCustomizeSyllabus =
        localStorage.getItem("dummyQuestionTest") === "true";
    }
  }
};
</script>
